export { default as DefaultPage } from './DefaultPage';
export { default as FilterTable } from './FilterTable';



// WEBPACK FOOTER //
// ./src/features/common/index.js